export default "__VITE_PUBLIC_ASSET__1e33534b__"